/**
 * Created by vladislav on 1/26/2024
 */

const SamsungLogic = function () {
    PlatformLogic.call(this);

    // Samsung host supports only http/1.1 - browser runs only 6 requests simultaneously
    cc.CONCURRENCY_HTTP_REQUEST_COUNT = 6;
};

SamsungLogic.prototype = Object.create(PlatformLogic.prototype);
SamsungLogic.prototype.constructor = SamsungLogic;

SamsungLogic.prototype.reportScore = function (score, callback) {
    GSInstant.setScoreAsync(score).then(() => {
        callback(cleverapps.CODE_SUCCEED);
    }).catch(() => {
        callback(cleverapps.CODE_FAILED);
    });
};